import { AxiosError } from 'axios';
import { OIDCTokenRequest } from 'web-library/models/OIDCAuth';
import axiosClient from '../axiosClient';
import { POST_MIMS_CALLBACK_URL } from '../../constants/apiUrls';
import { useCustomMutation } from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";
// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess: () => void;
  onError: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostMIMSCallback = ({ onSuccess, onError }: Input) => {
  const postMIMSCallback = async (data: OIDCTokenRequest) => {
    const res = await axiosClient.post<void>(POST_MIMS_CALLBACK_URL, data);

    return res.data;
  };

  return useCustomMutation(
    postMIMSCallback,
    {
      onSuccess,
      onError,
    },
    false
  );
};
